import React from 'react'
import ChartCard from './ChartCard'

const data= {
    id:0,
    title:"users",
    d1:150,
    d2:100,
    color:"#ff0000"

  }

function HeroCharts({data}) {
  return (
<div className=" container py-7 ">
<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-col-2 xl:grid-cols-4">
{data.map((item ,index) =>(
  <ChartCard key={index} data={item} />

))}
        
      
</div>
     
</div>
  )
}

export default HeroCharts